import { render, staticRenderFns } from "./personAdd.vue?vue&type=template&id=91bbc9de&scoped=true&"
import script from "./personAdd.vue?vue&type=script&lang=js&"
export * from "./personAdd.vue?vue&type=script&lang=js&"
import style0 from "./personAdd.vue?vue&type=style&index=0&id=91bbc9de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bbc9de",
  null
  
)

/* custom blocks */
import block0 from "./personAdd.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports